import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import styles from './ColumnLayout.scss';
import Contents from './Contents';
import Headings from './Headings';
import Images from './Images';

interface Props {
  slides: ProspectHomepageSlide[];
}

const ColumnLayout: React.FC<Props> = ({ slides }) => {
  const headings: ProspectHomepageSlide['heading'][] = [];
  const images: ProspectHomepageSlide['image_with_text'][] = [];
  const contents: ProspectHomepageSlide['content'][] = [];

  let contentRowsCount = 0;

  for (const slide of slides) {
    headings.push(slide.heading);
    images.push(slide.image_with_text);
    contents.push(slide.content);
    contentRowsCount = Math.max(slide.content.length, contentRowsCount);
  }

  return (
    <div className={classNames(styles.columnLayout, { [styles.twoSlides]: slides.length === 2 })}>
      <Headings headings={headings} />
      <Images images={images} />
      <Contents contentRowsCount={contentRowsCount} contents={contents} />
    </div>
  );
};

export default ColumnLayout;
